var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imageType)?_c('img',{staticClass:"mx-auto max-h-20 w-auto mb-8",attrs:{"src":_vm.imgSrc,"alt":"Studio logo"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }